module.exports = __webpack_public_path__ + "images/457d277467348d0b6e0a2b6488326cc1.png";